module.exports = __webpack_public_path__ + "static/media/test23.6d596d3f.jpeg";